import React from "react";

type TProps = {
    height? : string
    width? : string
}

const Spacer = ({height = "10%", width = "100%"}:TProps) => {
    return (
        <div style={{
            height: height,
            width: width,
        }}>&nbsp;</div>
    );
}

export default React.memo(Spacer);